import { SagaIterator, Task } from "redux-saga";
import { all, call, cancel, delay, fork, take } from "saga-query";

const pollMap: { [key: string]: Task | undefined } = {};
export function pollMatrix(parentTimer?: number) {
  return function* poller(
    actionType: string,
    saga: any,
    ...args: any[]
  ): SagaIterator<void> {
    function* fire(
      action: { type: string; payload?: { timer?: number } },
      timer: number
    ) {
      while (true) {
        yield* call(saga, action, ...args);
        yield* delay(timer);
      }
    }

    function* watcher(): SagaIterator<void> {
      while (true) {
        const action_ = yield* take(`${actionType}`);
        const action = action_ as any;
        const timer = action["payload"]?.timer || parentTimer;
        const task: Task = yield* fork(fire, action, timer);
        pollMap[action["payload"].key] = task;
      }
    }

    function* canceler(): SagaIterator<void> {
      while (true) {
        const action: { type: string; payload?: string } = yield* take(
          `cancel-${actionType}`
        );
        const watcherKeyStr = action.payload as any;
        const task = pollMap[watcherKeyStr];
        if (!task) {
          continue;
        }
        yield* cancel(task);
        pollMap[watcherKeyStr] = undefined;
      }
    }

    yield* all([call(canceler) as any, call(watcher)]);
  };
}
